<ion-header *ngIf="order$ | async as order">
  <div class="left">
    <div class="back-button" (click)="onBackButtonClick()">
      <app-svg-icon [name]="'arrow-back'"></app-svg-icon>
    </div>
    <div class="title">
      {{
        "@pages.orderDetails.header"
          | translate
            : {
                orderId: order.id
              }
      }}
    </div>
  </div>
</ion-header>
<ion-content>
  <div *ngIf="order$ | async as order" class="content">
    <app-order-list-item-header [order]="order"></app-order-list-item-header>
    <div class="item-list">
      <div *ngIf="order.type === orderTypes.DELIVERY" class="by-days">
        <div class="day" *ngFor="let day of getOrderDeliveryDays(order)">
          <div class="order-item-list in-store-list">
            <ng-container
              *ngFor="
                let orderItem of order.items
                  | filterOrderItemsByDay : day
                  | async
              "
            >
              <app-order-item
                [label]="orderItem.item.name"
                [price]="orderItem.prices | getPrimaryCurrencyPrice"
                [amount]="orderItem.quantity"
              ></app-order-item>
              <app-order-list-item-status
                [order]="order"
                [orderItem]="orderItem"
              ></app-order-list-item-status>
            </ng-container>
          </div>
        </div>
      </div>

      <div *ngIf="order.type === orderTypes.IN_STORE" class="">
        <div class="order-item-list">
          <ng-container *ngFor="let orderItem of order.items">
            <app-order-item
              [label]="orderItem.item.name"
              [price]="orderItem.prices | getPrimaryCurrencyPrice"
              [amount]="orderItem.quantity"
            ></app-order-item>
            <app-order-list-item-status
              [order]="order"
              [orderItem]="orderItem"
            ></app-order-list-item-status>
          </ng-container>
        </div>
      </div>
    </div>
    <div *ngIf="order$ | async as order" class="info-block delivery-to">
      <div *ngIf="order.type === orderTypes.DELIVERY" class="header">
        {{ "@pages.orderDetails.deliveredTo.header" | translate }}
      </div>
      <div *ngIf="order.type === orderTypes.IN_STORE" class="header">
        {{ "@pages.orderDetails.pickedUpFrom.header" | translate }}
      </div>
      <div class="text">
        {{ order.location.name }}, {{ order.location.address || "..." }}
      </div>
    </div>
    <div *ngIf="order$ | async as order" class="prices">
      <div class="item">
        <div class="label total">
          {{ "@pages.orderSummary.prices.total" | translate }}
        </div>
        <app-price-label
          [value]="order.prices | appCurrency | async"
          [noIcon]="true"
        ></app-price-label>
      </div>
    </div>
    <div *ngIf="(order$ | async) === null" class="loader">
      <ion-spinner class="app-spinner"></ion-spinner>
    </div>
  </div>
</ion-content>
<ion-footer *ngIf="order$ | async as order">
  <div class="footer">
    <!-- <app-action-button
      *ngIf="!order.delivered"
      (click)="onConfirmReceiving()"
      [label]="'@pages.orderDetails.confirmReceivingBtn' | translate"
    ></app-action-button> -->
    <!-- <app-action-button
      (click)="onDownload()"
      [label]="'@pages.orderDetails.actionBtn' | translate"
      [isOutlined]="true"
    ></app-action-button> -->
  </div>
</ion-footer>
